// extracted by mini-css-extract-plugin
export var drawerPaper = "_1g-0";
export var itemImage = "_1g-1";